import 'whatwg-fetch';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import qs from 'query-string'
import './styles.scss';
import { API_ROOT } from 'signoxe/constants/config';
import { TICKER_FEED_RESOURCE } from "signoxe/api/resources";
import { connect } from 'react-redux';
import {
  getClient, getProfile, 
} from 'signoxe/selectors';
import { 
  fetchClient
} from '../../actions';

class TickerPlayer extends React.PureComponent {

  static propTypes = {
    className: PropTypes.string,
    disableOverlay: PropTypes.bool,
    background: PropTypes.string,
    colour: PropTypes.string,
    outline: PropTypes.string,
    speed: PropTypes.number,
    width: PropTypes.number,
    index: PropTypes.number,
    fontFamily: PropTypes.string,
    fontSize: PropTypes.string,
    text: PropTypes.string,
    isURL: PropTypes.bool,
    // onTickerEnd: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.ticketPlayerRef = null;
    this.state = {
      styleHeight: null,
      urlLoaded: false,
      loadedText: null,
      allowNextTicker: true,
    };
  }

  componentDidMount() {
    this.props.fetchClient()
    if (this.props.isURL) {
      this.loadTickerTextFromURL(this.props.text);
    } else {
      if (this.tickerText && this.props.text) {
        this.setAnimation(this.props.speed, this.props.text.length);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.tickerText.style.animation = '';

    if (nextProps.isURL) {
      this.loadTickerTextFromURL(nextProps.text);
    } else {
      setTimeout(() => {
        this.setAnimation(nextProps.speed, nextProps.text.length);
      }, 10);
    }
  }

  render() {
    const {background, colour, fontFamily, fontSize, outline, onTickerEnd, isURL, index} = this.props;
    let text = this.props.text;
    if (isURL) {
      if (this.state.urlLoaded) {
        text = this.state.loadedText;
      } else {
        text = '';
      }
    }

    const textShadow = outline
      ? `-1px -1px 0 ${outline}, 1px -1px 0 ${outline},-1px 1px 0 ${outline}, 1px 1px 0 ${outline}`
      : null;
    
    const { MyClient } = this.props;
    const {clientProfile} =  this.props;
    const MyClientempty = _.isEmpty(MyClient);

    setTimeout(() => {
      if(this.ticketPlayerRef && this.props.disableOverlay){
        const currentHeight = this.ticketPlayerRef.querySelector('.ticker').clientHeight;
        if(this.state.styleHeight !== currentHeight) {
          this.setState({
            styleHeight: currentHeight
          });
        }
      }
    }, 100);

    const style = {};
    if(this.state.styleHeight) {
      style.height = `${this.state.styleHeight}px`;
    }
    if(this.props.width){
      style.width = `${this.props.width}px`;
    }

    return (
      <div className={classNames('ticker-player', this.props.className)}
        style={style}
        ref={(el) => this.ticketPlayerRef = el}>
        <div className="ticker" style={{backgroundColor: background}}>
          {
            clientProfile != undefined?
            clientProfile.features.change_device_logo ? (
            !MyClientempty && _.map(MyClient, (client, key) => (
              <>
                {
                  client.display_device_logo? 
                    client.device_logo !== null? 
                      <img src={client.device_logo.replace("/api", "/app")} alt="" className='logo_img'/>
                        :
                      <img src={client.logo.replace("/api", "/app")} alt="" className='logo_img'/>
                  :null
                }
              </>
            ))
          ): null: null}

          <div className="text"
               ref={(elem) => this.tickerText = elem}
               style={{
                 color: colour,
                 fontSize: `${fontSize}pt`,
                 fontFamily,
                 textShadow,
               }}
             >{text}</div>
        </div>
      </div>
    );
  }

  // setAnimation(speed, length) {
  //   this.tickerText.style.animation =
  //     `ticker-preview-animation ${speed * length}ms linear`;
  // }
  setAnimation(speed, length) {
    if (this.tickerText) {
      this.tickerText.style.animation =
        `ticker-preview-animation ${speed * length}ms linear`;
    } else {
      console.log("this.tickerText is null or undefined");
    }
  }

  loadTickerTextFromURL(url) {
    this.setState({allowNextTicker: false});
    const requestOptions = {
      method: 'GET',
      headers: {},
    };
    fetch(`${API_ROOT}${TICKER_FEED_RESOURCE}/?` + qs.stringify({url}), requestOptions).then(response => {
        if (response.ok) {
          return response.json();
        }
    }).then(obj => {
      if (obj) {
        const text = obj.entries.map(item => item.title).join(' - ');
        this.setState({urlLoaded: true, loadedText: text, allowNextTicker: true});
        setTimeout(() => {
          this.setAnimation(this.props.speed, text.length);
        }, 50);
      }
    });
  }
}

export default connect((state) => ({
  clientProfile: getProfile(state),
  MyClient : getClient(state),
}), {
  fetchClient
})(TickerPlayer);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/TickerPlayer/index.js